import React from "react";
import { Link } from "react-router-dom";
// reactstrap components
import {
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
  UncontrolledTooltip
} from "reactstrap";

class Footer extends React.Component {
  render() {
    return (
      <footer className="footer">
        <Container>
          <Row>
            <Col md="12" style={{textAlign:'center'}}>
              <h4 className="mb-0 font-weight-light">Made with <span role="img" aria-label="heartemoji">&#10084;&#65039;</span> in India</h4>
            </Col>
          </Row>
        </Container>
      </footer>
    );
  }
}

export default Footer;
